import { IBreadcrumbs } from '@app/shared/interfaces/breadcrumbs.interface';

export const productBreadCrumbs: IBreadcrumbs[] = [
  {
    id: 1,
    breadCrumbTitle: 'wejoiner',
    breadCrumbUrl: '/',
  },
  {
    id: 2,
    breadCrumbTitle: 'home.categories',
    breadCrumbUrl: '/categories',
  },
];
